module.exports = __webpack_public_path__ + "e2c8ed214d55620328d66d88c5af70fd.svg";